import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Container, Row, Col } from "react-bootstrap";
import UIInfiniteScroll from "../../components/UI/InfiniteScroll/InfiniteScroll";
import { LoaderSmall } from "../../components/Loader";
import { useUserData } from "../../hooks/UserContext";
import CardProduct from "../../components/CardProduct";
import Filter from "../../components/Filter";
import Scroll from "../../components/ScrollToTop";
import { useNavigate } from "react-router";
import NotFound from "../ErrorPage/notFound";
import Grid from "@mui/material/Grid";
import { clientesApi } from "../OrderResumePag/_services/api";

import {
  SearchResultText,
  DidYouMeanText
} from './styles';

import {
  fetchProducts,
  selectBrands,
  selectCategories,
  selectOrder,
  toggleCheckBrand,
  toggleCheckCategory,
  clearCheckBrand,
  clearCheckCategories,
  setRangeSlide,
  setBorderPrices
} from "../../Redux/filterSlice";

import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { trackViewItemListMarketplace, trackSelectItemMarketplace, trackAddToWishlistMarketplace } from "../../utils/gtm";
import { useScreenTracking } from '../../hooks/useScreenTracking';

export default function Product() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [newPage, setNewPage] = useState(0);
  const [acceptNextPage, setAcceptNextPage] = useState(false);
  const [limit, setLimit] = useState(process.env.REACT_APP_DEFAULT_LIMIT_PAGE);
  const order = useSelector(selectOrder);
  const brands = useSelector(selectBrands);
  const categories = useSelector(selectCategories);
  const [brandsFilter, setBrandsFilter] = useState([]);
  const [count, setCount] = useState(0);
  const [categoriesFilter, setCategoriesFilter] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [lastId, setLastId] = useState("");
  const [hasSetPriceRange, setHasSetPriceRange] = useState(false);
  const [didYouMean, setDidYouMean] = useState(null);

  const { desc } = useParams();

  const jwt = useUserData();
  const dataUser = jwt.userData.data;
  const [enterJWT, setEnterJWT] = useState(false);
  const [wishlistData, setWishlistData] = useState([]);

  const cpf = dataUser?.cpf;

  const disp = useDispatch();

  const navigate = useNavigate();
  const screenName = useScreenTracking()

  useEffect(() => {
    if (jwt.userData?.data && !enterJWT) {
      setEnterJWT(true);
    }
    // eslint-disable-next-line
  }, [jwt.userData, enterJWT]);

  async function apiWishlist() {
    if (!dataUser?.cpf) {
      console.warn("CPF não encontrado no dataUser, retornando array vazio para wishlist");
      return [];
    }
    
    try {
      const response = await clientesApi.get(
        `/customer/${dataUser.cpf}/wishlist`,
      );
      return response.data.data;
    } catch (error) {
      console.error("Erro ao buscar wishlist:", error);
      return [];
    }
  }

  useEffect(() => {
    disp(clearCheckBrand());
    disp(clearCheckCategories());
    localStorage.removeItem("orderFilter");
    setNewPage(0);
    setProducts([]);
    setCount(0);
    setHasSetPriceRange(false);
    setNotFound(false);
    setDidYouMean(null);
  }, [desc]);

  function onClickCategory(idCategory) {
    for (let i in categories) {
      if (idCategory === categories[i].id) {
        disp(
          toggleCheckCategory({
            id: idCategory,
          })
        );
        break;
      }
    }
  }

  function onClickBrand(idBrand) {
    for (let i in brands) {
      if (idBrand === brands[i].id) {
        disp(
          toggleCheckBrand({
            id: idBrand,
          })
        );
        break;
      }
    }
  }

  function onClickApplyFilter() {
    setNewPage(0);
    setHasSetPriceRange(true);
    setAcceptNextPage(false);
    setProducts([]);
    setCount(count + 1);
  }

  function onClickClearFilter() {
    window.location.reload();
  }

  async function fetchMore() {
    setLoadingProducts(true);
    const page = newPage + 1;
    setNewPage(() => page);
  }

  useEffect(() => {
    const fetchData = async () => {
      if (lastId !== desc) setLoading(true);
      setLoadingProducts(true);
      if (typeof cpf !== "undefined") {
        const wishlistData = await apiWishlist();
        setWishlistData(wishlistData);

        disp(fetchProducts({ newPage, limit, cpf, desc, screenName }))
          .unwrap()
          .then((payload) => {
            const response = payload;
            let pageCount;

            if (response.did_you_mean?.trim()) {
              setDidYouMean(response.did_you_mean);
            }

            if (!response.data || response.data.length === 0 || response.total === 0) {
              if (newPage === 0) {
                setNotFound(true);
                setProducts([]);
              }

              setAcceptNextPage(false);
              pageCount = 0;
              setLoadingProducts(false);
              setLoading(false);
              return;
            } else {
              pageCount = Math.ceil(response.total / response.per_page);
              setNotFound(false);

              if (!hasSetPriceRange && newPage === 0) {
                const minPrice = Math.round((Number(response.price_min) + Number.EPSILON) * 100) / 100;
                const maxPrice = Math.round((Number(response.price_max) + Number.EPSILON) * 100) / 100;
                disp(setBorderPrices({
                  lowerValue: minPrice,
                  greaterValue: maxPrice,
                }));

                disp(setRangeSlide({ value: maxPrice }));
                setHasSetPriceRange(true);
              }
            }

            const currentPageNumber = response.page || (newPage + 1);
            const isLastPage = currentPageNumber >= pageCount || response.data.length < response.per_page;

            if (isLastPage) {
              setAcceptNextPage(false);
            } else {
              setAcceptNextPage(true);
            }

            if (response.data && response.data.length > 0) {
              if (newPage === 0) {
                setProducts(response.data);
              } else {
                setProducts(prevProducts => [...prevProducts, ...response.data]);
              }

              if (newPage === 0) {
                trackViewItemListMarketplace({
                  itemListName: desc,
                  items: response.data.map((p, i) => ({
                    itemId: p.uuid,
                    itemName: p.label,
                    discount: Math.max(0, (p.product_price.price_suggested || 0) - (p.product_price.price || 0)),
                    index: i,
                    itemBrand: p.brand_name || "",
                    itemCategory: p.product_categories?.[0]?.category_name || "",
                    price: p.product_price?.price || 0,
                    quantity: 1,
                  })),
                });
              }
            }

            setLoadingProducts(false);
            setLoading(false);
            setLastId(desc);
          })
          .catch((err) => {
            console.log(err);

            setDidYouMean(null);
            
            if (newPage === 0) {
              setNotFound(true);
              setProducts([]);
            }

            setAcceptNextPage(false);
            setLoadingProducts(false);
            setLoading(false);
          });
      }
    };
    fetchData();
  }, [desc, newPage, count, cpf]);

  if (loading) return <LoaderSmall />;

  return (
    <Container className="pt-4">
      <div className="wl-page">
        <div className="d-flex justify-content-between align-items-center mt-2 mb-4">
          <div>
            <SearchResultText hasDidYouMean={!!didYouMean} className="fw-bold">
              Resultado da busca: <i>’{desc}’</i>
            </SearchResultText>
              {didYouMean && (
                <div className="mt-1">
                  <DidYouMeanText className="fw-bold">
                    Você quis dizer: <i>’{didYouMean}’</i>
                  </DidYouMeanText>
                </div>
              )}
          </div>
          <div>
            <Filter
              target={"Produtos"}
              onClickBrand={onClickBrand}
              onClickCategory={onClickCategory}
              onClickApplyFilter={onClickApplyFilter}
              onClickClearFilter={onClickClearFilter}
            />
          </div>
        </div>
        <Row className="mt-5">
          {notFound && products.length === 0 && <NotFound />}

          {products.map((buy, index) => {
            const { uuid, label } = buy;
            const priceFormatted = {
              BRL: {
                offer: Math.round(buy?.product_price?.price) ?? 0,
                price: buy?.product_price?.price_suggested !== buy?.product_price?.price ? Math.round(buy.product_price.price_suggested) : null
              },
              points: {
                offer: Math.round(buy?.product_price?.points_suggested) ?? 0,
                price: buy?.product_price?.points !== buy?.product_price?.points_suggested ? Math.round(buy.product_price.points) : null
              },
            };

            const isInWishlist = wishlistData.some((item) => item.product_uuid === uuid);

            return (
              <Col xs={6} key={uuid} className="pb-4">
                <CardProduct
                  id={uuid}
                  label={label}
                  image={buy.images[0]?.path}
                  price={priceFormatted}
                  campaign=""
                  wishlist={isInWishlist}
                  cashback=""
                  searchColorButton={false}
                  onProductClick={() => trackSelectItemMarketplace({
                    itemListName: desc,
                    itemId: buy.uuid,
                    itemName: buy.label,
                    discount: Math.max(0, (buy.product_price.price_suggested || 0) - (buy.product_price.price || 0)),
                    index: index,
                    itemBrand: buy.brand_name || "",
                    itemCategory: buy.product_categories?.[0]?.category_name || "",
                    price: buy.product_price?.price || 0,
                    quantity: 1,
                  })}
                  onAddToWishlist={() => trackAddToWishlistMarketplace({
                    itemListName: desc,
                    itemId: buy.uuid,
                    itemName: buy.label,
                    discount: Math.max(0, (buy.product_price.price_suggested || 0) - (buy.product_price.price || 0)),
                    index: index,
                    itemBrand: buy.brand_name || "",
                    itemCategory: buy.product_categories?.[0]?.category_name || "",
                    price: buy.product_price?.price || 0,
                    quantity: 1,
                  })}
                />
              </Col>
            );
          })}

          {products && !loadingProducts && acceptNextPage && (
            <UIInfiniteScroll fetchMore={() => fetchMore()} />
          )}
        </Row>
      </div>

      {loadingProducts && (
        <div className="text-center mb-5">
          <span className="spinner-border color-wl" role="status" />
        </div>
      )}
      <Scroll />
    </Container>
  );
}
